import { PureComponent } from 'react';
import { View, Image } from 'react-native';
import { connect } from '@symbolic/redux';
import { resourceActions } from '~/redux';
import { api } from '@symbolic/lib';

import FileInput from '~/components/file-input';
import handleFileUpload from '~/helpers/upload-file-helper';

import thumbnailPlaceholder from '~/assets/thumbnail-placeholder.png';

import _ from 'lodash';

class ProductInstanceMedia extends PureComponent {
  state = {
    image: null,
    uploading: false,
    uploadWasSuccessful: false,
    uploadHasFailed: false
  };

  render() {
    var {activeProductInstance, allowFileUpload = true, scale = 1.0, dimensionsAreVisible = false} = this.props;

    // Match ProductGraphic sizing logic:
    // Target size from debug: 380x468 (typical product rendering)
    // Work backwards: if (productSize * scale) + padding = 380x468
    // With scale=2.5 and padding=40: productSize = (targetSize - 40) / 2.5
    // Width: (380 - 40) / 2.5 = 136mm
    // Height: (468 - 40) / 2.5 = 171.2mm
    const productWidth = 136; // in mm
    const productHeight = 171.2; // in mm

    const padding = dimensionsAreVisible ? 20 * 2 : 20; // Match ProductGraphic padding logic

    var scaledWidth = (productWidth * scale) + padding;
    var scaledHeight = (productHeight * scale) + padding;

    if (dimensionsAreVisible) {
      scaledWidth -= (30 * 2);
      scaledHeight -= (30 * 2);
    }

    return (
      <View style={{padding: dimensionsAreVisible ? 30 : 0, alignItems: 'center'}}>
        <View style={{height: scaledHeight, width: scaledWidth}}>
          <Image source={activeProductInstance.thumbnailUrl ? {uri: activeProductInstance.thumbnailUrl} : thumbnailPlaceholder} style={{resizeMode: 'contain', alignSelf: 'center', overflow: 'hidden', width: '100%', height: '100%'}}/>
        </View>
        {allowFileUpload && (
          <FileInput
            containerStyle ={{justifyContent: 'center'}}
            uploading={this.state.uploading}
            uploadWasSuccessful={this.state.uploadWasSuccessful}
            uploadHasFailed = {this.state.uploadHasFailed}
            handleFilesPicked={(files) => handleFileUpload({files,
              setState: (newState) => this.setState(newState),
              api,
              type: 'image',
              resource: activeProductInstance,
              session: this.props.session,
              resourceKey: 'productInstance',
              trackResource: ({productInstances}) => this.props.trackProductInstances({productInstances})
            })}
          />
        )}
      </View>
    );
  }
}

export default connect({
  mapState: (state, ownProps) => {

  },
  mapDispatch: {
    ..._.pick(resourceActions.productInstances, ['trackProductInstances']),
  }
})(ProductInstanceMedia);
